// import React from "react";
// import noDataFoundIcon from "../../assets/noDataFoundIcon.svg";

// const NoDataFound = ({
//   className = "",
//   message = "No Data Available",
//   subMessage = "There are no records to display",
//   minimal = false,
// }) => {
//   return (
//     <div className={`${className} w-full`}>
//       <div
//         className={`
//         bg-white rounded-lg border border-gray-200
//         ${minimal ? "py-4" : "py-8"}
//         flex flex-col items-center justify-center
//         text-center
//       `}
//       >
//         <img
//           src={noDataFoundIcon}
//           className={`${minimal ? "h-12 w-12" : "h-16 w-16"} opacity-90 mb-3`}
//           alt="No data found"
//         />

//         <div className="space-y-1">
//           <h3
//             className={`
//             font-medium
//             ${minimal ? "text-sm text-gray-600" : "text-base text-gray-700"}
//           `}
//           >
//             {message}
//           </h3>
//           {!minimal && <p className="text-xs text-gray-500">{subMessage}</p>}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NoDataFound;
import React from "react";
import { FiPieChart } from "react-icons/fi";
import { motion } from "framer-motion";

const NoDataFound = ({
  message = "No data available",
  subMessage = "There are no records to display at this time",
  actionText = "Refresh Data",
  onAction,
  minimal = false,
  className = "",
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      className={`${className} w-full ${minimal ? "py-4" : "py-8"}`}
    >
      <motion.div
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.3 }}
        className="w-full"
      >
        {/* Main container with floating animation */}
        <motion.div
          animate={{
            y: [0, -3, 0],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="bg-white rounded-xl border border-gray-200 shadow-xs overflow-hidden w-full"
        >
          {/* Animated gradient background */}
          <motion.div
            animate={{
              backgroundPosition: ["0% 0%", "100% 100%"],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              repeatType: "reverse",
              ease: "linear",
            }}
            className="bg-gradient-to-r from-blue-50 via-indigo-50 to-blue-50 bg-[length:200%_200%] p-6 flex justify-center"
          >
            <motion.div
              animate={{
                rotate: [0, 5, -5, 0],
                scale: [1, 1.05, 1],
              }}
              transition={{
                duration: 2.5,
                repeat: Infinity,
                repeatType: "reverse",
              }}
              className="p-4 rounded-full bg-white shadow-sm border border-gray-100"
            >
              <FiPieChart className="h-7 w-7 text-indigo-600" />
            </motion.div>
          </motion.div>

          {/* Content section */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="p-6 text-center space-y-4"
          >
            <div className="space-y-2">
              <motion.h3
                initial={{ y: 10 }}
                animate={{ y: 0 }}
                transition={{ delay: 0.3 }}
                className="text-lg font-semibold text-gray-800"
              >
                {message}
              </motion.h3>
              <motion.p
                initial={{ y: 10 }}
                animate={{ y: 0 }}
                transition={{ delay: 0.4 }}
                className="text-sm text-gray-500"
              >
                {subMessage}
              </motion.p>
            </div>

            {!minimal && onAction && (
              <motion.button
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
                whileHover={{
                  y: -2,
                  boxShadow: "0 4px 12px rgba(99, 102, 241, 0.15)",
                }}
                whileTap={{ scale: 0.98 }}
                onClick={onAction}
                className="px-5 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-indigo-600 to-indigo-500 hover:from-indigo-500 hover:to-indigo-400 rounded-lg transition-all"
              >
                {actionText}
              </motion.button>
            )}
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default NoDataFound;